import { AppShell } from "@/components/layout/AppShell";
import { PRIVACY_EMAIL, PRIVACY_PREPARED, PRIVACY_SECTIONS } from "@/components/legal/privacy";
import { Seo } from "@/components/Seo";
import { env } from "@/env";
import { useT } from "@/lib/i18n";

const URL_PATTERN = /(https?:\/\/[^\s]+[^\s.,;)])/u;

function Linked({ text }: { text: string }) {
  let cursor = 0;
  return (
    <>
      {text.split(URL_PATTERN).map((part) => {
        const key = cursor;
        cursor += part.length;
        return part.startsWith("http") ? (
          <a
            className="text-brand underline"
            href={part}
            key={key}
            rel="noreferrer"
            target="_blank"
          >
            {part}
          </a>
        ) : (
          part
        );
      })}
    </>
  );
}

export function PrivacyPage() {
  const t = useT();
  const title = t("privacy.title", { name: env.appName });
  return (
    <AppShell>
      <Seo description={t("privacy.description", { name: env.appName })} path="/privacy" title={title} />
      <article className="mx-auto max-w-3xl" dir="ltr" lang="en">
        <h1 className="text-2xl font-semibold text-ink">{title}</h1>
        <p className="mt-1 text-sm text-ink-muted">English version. Prepared {PRIVACY_PREPARED}.</p>

        <nav aria-label="Contents" className="mt-6 rounded-panel border border-line bg-surface-sunken p-4">
          <ol className="grid list-decimal gap-1 ps-5 text-sm sm:grid-cols-2">
            {PRIVACY_SECTIONS.map((section) => (
              <li key={section.id}>
                <a className="text-brand hover:underline" href={`#${section.id}`}>
                  {section.title}
                </a>
              </li>
            ))}
          </ol>
        </nav>

        <div className="mt-8 flex flex-col gap-8">
          {PRIVACY_SECTIONS.map((section, index) => (
            <section aria-labelledby={`h-${section.id}`} id={section.id} key={section.id}>
              <h2 className="text-lg font-semibold text-ink" id={`h-${section.id}`}>
                {index + 1}. {section.title}
              </h2>
              <div className="mt-2 flex flex-col gap-3 text-sm leading-relaxed text-ink-muted">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph}>
                    <Linked text={paragraph} />
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <p className="mt-10 text-sm text-ink-muted">
          Questions about this policy:{" "}
          <a className="text-brand underline" href={`mailto:${PRIVACY_EMAIL}`}>
            {PRIVACY_EMAIL}
          </a>
        </p>
      </article>
    </AppShell>
  );
}
